import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dispersionStatus'
})
export class DispersionStatusPipe implements PipeTransform {

  transform(id: number): string | null {
    let status: string;
    switch (id) {
      case 1:
        status = '<i class="fas fa-exclamation-triangle status-1 status-ico"></i>';
        break;
      case 2:
        status = '<i class="far fa-check status-2 status-ico"></i>';
        break;
      case 3:
        status = '<i class="far fa-check-square status-3 status-ico"></i>';
        break;
      case 4:
        status = '<i class="fa fa-times status-4 status-ico"></i>';
        break;
      case 5:
        status = '<i class="fas fa-ban status-5 status-ico"></i>';
        break;
      case 6:
        status = '<i class="fas fa-arrow-right status-6 status-ico"></i>';
        break;
      case 7:
        status = '<i class="fa fa-exclamation-circle status-4 status-ico"></i>';
        break;
      default:
        status = 'No data';
        break;
    }
    return status;
  }

}